import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { ACCOUNT_STATUS } from '../../../constants'
import { getMergedPlan } from '../../../constants/plans'
import { getProviderLabel } from '../../../utils/paymentProvider'
import styles from './PastDuePaymentModal.module.css'

function PastDuePaymentModal({ profile }) {
  const [show, setShow] = useState(true)

  const isPastDue = profile?.status?.toUpperCase() === ACCOUNT_STATUS.PAST_DUE

  if (!isPastDue || !show) return null

  const period = profile?.interval === 'month' ? 'monthly' : 'yearly'
  const plan = profile?.productId ? getMergedPlan(profile.productId, profile.currency) : null
  const planName = plan?.label || 'your plan'
  const priceData = plan?.prices?.[period]
  const price = priceData?.value ? `${priceData.symbol || '$'}${priceData.value}` : null
  const providerLabel = getProviderLabel(profile)

  const handleCompletePayment = () => {
    if (profile.hostedInvoiceUrl) {
      window.open(profile.hostedInvoiceUrl, '_blank')
    }
  }

  const handleClose = () => {
    setShow(false)
  }

  return (
    <Modal show onHide={handleClose} centered dialogClassName={styles.dialog}>
      <Modal.Body className={styles.body}>
        <div className={styles.iconRow}>
          <img src="/assets/icons/warning_black.svg" height={28} width={28} alt="warning" />
        </div>

        <h4 className={styles.title}>Your last payment failed</h4>

        <p className={styles.description}>Please complete your payment to avoid losing your account.</p>

        <div className={styles.planBox}>
          <div className={styles.planName}>{planName}</div>
          {price && (
            <div className={styles.planPrice}>
              {price} /{period}
            </div>
          )}
        </div>

        <Button className={`w-100 mt-4 ${styles.payBtn}`} onClick={handleCompletePayment}>
          Complete payment
        </Button>

        <p className={styles.hint}>
          This will open your invoice on {providerLabel} where you can complete the payment.
        </p>
      </Modal.Body>
    </Modal>
  )
}

export default PastDuePaymentModal
